import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/strategyDetails.css"
import "../styles/modal.css";
import StrategyPickCard from "../components/Strategy_pick_card";
import StrategyStatsCard from "../components/StrategyStatsCard";
import StrategyDetailsInfo from "../components/InfoModals/StrategyDetailsInfo";

export default function StrategyDetails({ addToast }) {
    const { id } = useParams(); // URL-ből vesszük ki az ID-t
    const [strategy, setStrategy] = useState(null);
    const [picks, setPicks] = useState([]);
    const [activeTab, setActiveTab] = useState("overview");
    const [showModal, setShowModal] = useState(false);


    const [showInfo, setShowInfo] = useState(false)

    // Szükséges adatok
    const [odds, setOdds] = useState("");
    const [stake, setStake] = useState("");
    const [result, setResult] = useState("");



    //TITLE BEÁLLITÁS
    useEffect(() => {
        document.title = "Stratégiák - FociFanatik"
    }, []);


    // useEffect(() => {
    //     fetch("https://focifanatik.hu/api/session_check.php", {
    //         credentials: "include"
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             if (!data.loggedIn) {
    //                 window.location.href = "/regisztracio";
    //             }
    //         });
    // }, []);


    useEffect(() => {
        fetch(`https://focifanatik.hu/api/get_strategy.php?id=${id}`)
            .then((res) => res.json())
            .then((data) => setStrategy(data))
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [id]);


    useEffect(() => {
        fetch(`https://focifanatik.hu/api/get_strategy_picks.php?id=${id}`)
            .then((res) => res.json())
            .then((data) => setPicks(data))
            .catch((err) => console.error("Hiba a picks lekéréskor:", err));
    }, [id]);



    if (!strategy) return (<div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Betöltés...</span>
        </div>
    </div>);

    // Uj szelveny modal
    const handleSave = () => {
        const newStrategy = {
            strategy_id: id,
            odds: odds,
            stake: stake,
            result: result
        };

        fetch("https://focifanatik.hu/api/add_strategy_pick.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newStrategy)
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Új szelvény sikeresen hozzáadva!", "success");
                    handleCloseModal();

                    // Frissítsük a listát
                    fetch(`https://focifanatik.hu/api/get_strategy_picks.php?id=${id}`)
                        .then(r => r.json())
                        .then(d => setPicks(d));
                } else {
                    addToast("Hiba!", "warning");
                }
            })
            .catch(err => console.error("Hálózati hiba:", err));
    }


    const handleCloseModal = () => {
        setShowModal(false)
    };

    return (
        <div className="strategyDetails-page">
            <div className="container">
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                    {/* Fejléc */}
                    <div className="bg-success text-white text-center py-4 header-color">
                        <div className="info-button-left">
                            <button
                                className="btn-info-sd"
                                onClick={() => setShowInfo(true)}
                            >
                                <i class="bi bi-info-lg"></i>
                            </button>
                        </div>
                        <h1 className="mb-0">{"asd"}</h1>
                    </div>

                    {/* Menü */}
                    <div className="bg-light border-bottom">
                        <ul className="nav nav-pills nav-pills-color justify-content-center py-2">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "overview" ? "active" : ""}`}
                                    onClick={() => setActiveTab("overview")}
                                >
                                    Szelvények
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "stats" ? "active" : ""}`}
                                    onClick={() => setActiveTab("stats")}
                                >
                                    Statisztika
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "analysis" ? "active" : ""}`}
                                    onClick={() => setActiveTab("analysis")}
                                >
                                    Leírás
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Tartalom */}
                    <div className="card-body p-4">
                        {activeTab === "overview" && (
                            <>
                                <div className="d-flex text-center justify-content-center mb-3">
                                    <button
                                        className="btn btn-success btn-lg shadow-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 new-note-btn"
                                        onClick={() => {
                                            setShowModal(true);
                                            setOdds("");
                                            setStake("");
                                            setResult("");
                                        }}
                                    >
                                        <span>Új szelvény létrehozása</span>
                                    </button>
                                </div>


                                {picks.length === 0 ? (<p className="text-center text-muted">Nincsenek szelvények ehhez a stratégiához.</p>
                                ) : (
                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 g-md-4">
                                        {picks.map((s) => (
                                            <div className="col-12 col-sm-6 col-md-4 mb-4" key={s.id}>
                                                <StrategyPickCard strategyId={s.id} picks={picks} setPicks={setPicks} onDeleteUpdateId={s.id} odds={s.odds} stake={s.stake} result={s.result} created_at={s.created_at} addToast={addToast} />
                                            </div>
                                        ))}
                                    </div>)}

                            </>
                        )}

                        {/* InfoModal */}
                        {showInfo && <StrategyDetailsInfo onClose={() => setShowInfo(false)} />}

                        {activeTab === "stats" && (
                            <div className="text-center text-muted py-5">
                                <StrategyStatsCard strategyId={id} />
                            </div>
                        )}

                        {activeTab === "analysis" && (
                            <div className="text-center text-muted py-5">
                                <p>{strategy.description}</p>
                            </div>
                        )}
                    </div>

                    {/* Láb (vissza + dátum) */}
                    <div className="card-footer bg-light text-center py-3">
                        <button
                            className="btn btn-outline-success px-4"
                            onClick={() => window.history.back()}
                        >
                            <i className="bi bi-arrow-left me-2"></i> Vissza
                        </button>
                    </div>
                </div>
                {showModal && (
                    <>
                        {/* Sötét háttér */}
                        <div className="custom-modal-backdrop"></div>

                        <div className="custom-modal d-flex justify-content-center align-items-center">
                            <div className="custom-modal-content">

                                {/* CÍM */}
                                <div className="custom-modal-header">
                                    <h5 className="modal-title-custom">Új szelvény</h5>
                                    <button className="close-btn" onClick={handleCloseModal}>×</button>
                                </div>


                                {/* TARTALOM */}
                                <div className="custom-modal-body">
                                    <form>

                                        <div className="mb-3">
                                            <label className="form-label">Tét</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={stake}
                                                onChange={(e) => setStake(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Odds</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={odds}
                                                onChange={(e) => setOdds(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Eredmény</label>
                                            <select
                                                className="form-select"
                                                value={result}
                                                onChange={(e) => setResult(e.target.value)}
                                            >
                                                <option value="pending">- Függőben -</option>
                                                <option value="win">Nyertes</option>
                                                <option value="lose">Vesztes</option>
                                            </select>
                                        </div>

                                    </form>
                                </div>

                                {/* LÁB */}
                                <div className="custom-modal-footer">
                                    <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                                        Mégse
                                    </button>
                                    <button className="pretty-btn save-btn" onClick={handleSave}>
                                        Mentés
                                    </button>
                                </div>


                            </div>
                        </div>
                    </>
                )}

            </div >
        </div>
    );
}